(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {

  const openButton =
    event.target.closest(
      '[data-vibra-size-guide-open]'
    );

  if (openButton) {

    const dialogId =
      openButton.getAttribute(
        'aria-controls'
      );

    const dialog =
      document.getElementById(
        dialogId
      );

    if (
      dialog &&
      typeof dialog.showModal === 'function'
    ) {
      dialog.showModal();
    }

    return;
  }


  const closeButton =
    event.target.closest(
      '[data-vibra-size-guide-close]'
    );

  if (closeButton) {

    closeButton
      .closest(
        '[data-vibra-size-guide-dialog]'
      )
      ?.close();

  }

});


document.addEventListener(
  'click',
  (event) => {

    const dialog =
      event.target.closest(
        '[data-vibra-size-guide-dialog]'
      );

    if (
      !dialog ||
      event.target !== dialog
    ) {
      return;
    }


    const rect =
      dialog
        .querySelector(
          '.vibra-size-guide__panel'
        )
        ?.getBoundingClientRect();


    if (!rect) {
      return;
    }


    const outside =
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom;


    if (outside) {
      dialog.close();
    }

  }
);
  } catch(e) { console.error(e); }
})();

})();
